'/workpapers/:workpaperId/worksheets/:id/calculations/:calculationId';

import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';

async function deleteCalculation(id: string, worksheetId: string, workpaperId: string): Promise<void> {
    const { data } = await api.delete(`/workpapers/${workpaperId}/worksheets/${worksheetId}/calculations/${id}`);
    return data;
}

export function useDeleteCalculation(): UseMutationResult<void, unknown, { id: string; worksheetId: string }, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation(({ id, worksheetId }) => deleteCalculation(id, worksheetId, workpaperId), {
        onSettled: () => {
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
            queryClient.invalidateQueries(['workpapers', workpaperId, 'calculations']);
        },
    });
}
